import type { BankTransferView } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatCalendarDate, formatKrw } from '@/shared/lib';
import { Button } from '@/shared/ui';
import { BankAccountCopyRow } from './bank-account-copy-row';
export const OrderDepositGuide = ({
  orderId,
  transfer,
  taxInvoiceRequested,
  onEdit,
  onChangeMethod,
  onCancel,
  pending = false,
}: {
  readonly orderId: string;
  readonly transfer: BankTransferView;
  readonly taxInvoiceRequested: boolean;
  readonly onEdit: () => void;
  readonly onChangeMethod: () => void;
  readonly onCancel: () => void;
  readonly pending?: boolean;
}): ReactElement => {
  if (transfer.status !== 'READY')
    return (
      <p role="status">
        {transfer.status === 'DONE'
          ? '입금이 확인되었습니다.'
          : transfer.status === 'REFUND_PENDING'
            ? '환불 대기 중입니다.'
            : transfer.status === 'CANCELED'
              ? '환불이 완료되었습니다.'
              : transfer.status === 'EXPIRED'
                ? '입금 기한이 만료되었습니다.'
                : '계좌이체 주문이 취소되었습니다.'}
      </p>
    );
  return (
    <section aria-label="입금 안내" className="flex flex-col gap-8">
      <dl className="flex flex-col gap-5">
        <div>
          <dt>주문 번호</dt>
          <dd>{orderId}</dd>
        </div>
        <div>
          <dt>입금 계좌</dt>
          <dd>
            <BankAccountCopyRow bank={transfer.bank} />
          </dd>
        </div>
        <div>
          <dt>입금 금액</dt>
          <dd className="text-2xl font-semibold">{formatKrw(transfer.amount)}</dd>
        </div>
        <div>
          <dt>입금자명</dt>
          <dd>{transfer.depositorName}</dd>
        </div>
        <div>
          <dt>입금 기한</dt>
          <dd>{formatCalendarDate(transfer.dueAt.slice(0, 10))}</dd>
        </div>
        <div>
          <dt>세금계산서</dt>
          <dd>{taxInvoiceRequested ? '발행 요청' : '요청 안 함'}</dd>
        </div>
      </dl>
      <p>입금이 확인되면 메일로 알려 드립니다.</p>
      <div className="flex flex-wrap gap-3">
        <Button variant="outline" disabled={pending} onClick={onEdit}>
          입금자명·세금계산서 정보 수정
        </Button>
        <Button variant="outline" disabled={pending} onClick={onChangeMethod}>
          결제 방법 바꾸기
        </Button>
        <Button variant="outline" disabled={pending} onClick={onCancel}>
          주문 취소
        </Button>
      </div>
    </section>
  );
};
